import * as React from "react"
import { Fragment } from "react"
import { useTranslate } from "ra-core"
import {
    BulkDeleteWithConfirmButton,
    DatagridConfigurable,
    List,
    //SearchInput,
    TopToolbar,
    CreateButton,
    FilterButton,
    SelectColumnsButton,
    CloneButton,
    ExportButton,
    TextField,
    ReferenceField,
    ReferenceInput,
    SelectInput,
    TextInput,
    DateField,
    EditButton,
    WrapperField,
    ShowButton,
    BulkExportButton,
    usePermissions,
} from "react-admin"
import * as buttons from "components/ui/buttons"



const EquipmentDriverList = () => {
    const { permissions } = usePermissions()
    const translate = useTranslate()

    return (
        <List
            resource={`references/drivers`}
            title={translate('resources.equipmentdrivers.name')}
        >
            <DatagridConfigurable sx={{
                "& .RaDatagrid-headerCell": { 
                    fontWeight: 'bold' 
                }
            }} >
                <TextField source="name" label={translate("resources.equipmentdrivers.fields.name")} />
                <TextField source="varname" label={translate("resources.common.fields.varname")}/>
                <TextField source="description" label={translate("resources.common.fields.description")}/>
                <TextField source="parent_varname" label={translate("resources.common.fields.parent_varname")}/>
                <WrapperField label={translate("internal.actions")}>
                    <ShowButton label="" title={translate("ra.action.show")} />
                </WrapperField>
            </DatagridConfigurable>
        </List>
    )
}

export default EquipmentDriverList